import React, { ReactChild } from "react";
import styled from "styled-components";
import NextStageButton from "./NextStageButton";

interface Props {
  select: number;
  answer: number;
  nextStage: number | string;
  setScreen: React.Dispatch<React.SetStateAction<string>>;
  desc?: ReactChild;
}

const ResultComponent = ({
  select,
  answer,
  nextStage,
  setScreen,
  desc,
}: Props) => {
  return (
    <ResultContainer>
      <ResultTopSection>
        <Result $correct={select === answer}>
          {select === answer ? "정답" : "오답"}
        </Result>
        <RightSection>
          <ResultText>당신이 고른답: {select}</ResultText>
          <ResultText>정답: {answer}</ResultText>
        </RightSection>
      </ResultTopSection>

      {desc}
      <br />

      <FlexCenter>
        <NextStageButton
          nextStage={2}
          onClick={() => {
            if (nextStage === "result") setScreen("result");
            else setScreen(`stage${nextStage}`);
          }}
        />
      </FlexCenter>
    </ResultContainer>
  );
};

export default ResultComponent;

const ResultContainer = styled.div`
  margin-top: 10px;
`;

const ResultTopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;

  margin-bottom: 10px;
`;

const ResultText = styled.div`
  font-size: 24px;
`;

const RightSection = styled.div``;

const Result = styled.div<{ $correct?: boolean }>`
  font-size: 48px;
  color: ${({ $correct }) => ($correct ? "lightgreen" : "red")};
`;

const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
